(() => {
  const roots = Array.from(
    document.querySelectorAll(
      '.shopify-section-group-footer-group .kt-section:has(.kt-newsletter), .kt-footer-columns, #shopify-section-footer .kt-section',
    ),
  );
  const root = roots[0];
  if (!root || root.hasAttribute('data-footer-accordion-init')) return;
  root.setAttribute('data-footer-accordion-init', '');

  let menuCols = Array.from(root.querySelectorAll('.kt-footer-menu-col'));
  if (!menuCols.length) {
    menuCols = Array.from(root.querySelectorAll('.kt-grid__item')).filter((item) =>
      item.querySelector('.kt-linklist'),
    );
  }
  if (!menuCols.length) return;

  const mobileMq = window.matchMedia('(max-width: 767.98px)');

  const syncExpanded = (col) => {
    const heading = col.querySelector('.kt-heading');
    if (!heading) return;
    heading.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
  };

  const applyMode = () => {
    const isMobile = mobileMq.matches;
    menuCols.forEach((col) => {
      const heading = col.querySelector('.kt-heading');
      if (!heading) return;
      if (isMobile) {
        heading.setAttribute('role', 'button');
        heading.setAttribute('tabindex', '0');
        syncExpanded(col);
      } else {
        heading.removeAttribute('role');
        heading.removeAttribute('tabindex');
        heading.removeAttribute('aria-expanded');
      }
    });
  };

  menuCols.forEach((col) => {
    const heading = col.querySelector('.kt-heading');
    if (!heading) return;
    const toggle = (event) => {
      if (!mobileMq.matches) return;
      if (event.type === 'keydown') {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
      }
      col.classList.toggle('is-open');
      syncExpanded(col);
    };
    heading.addEventListener('click', toggle);
    heading.addEventListener('keydown', toggle);
  });

  applyMode();
  if (typeof mobileMq.addEventListener === 'function') {
    mobileMq.addEventListener('change', applyMode);
  } else if (typeof mobileMq.addListener === 'function') {
    mobileMq.addListener(applyMode);
  }
})();
